import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import { API } from "../../../../backend";
import authHeader from "../../../../services/auth-header";
import LineOfCreditPaymentDetailView from "../Paymentdetails/ViewPaymentDetail/LineOfCreditPaymentDetailview";
import Helper from "../../../../Helper";

export default function LineOfCreditPaymentChangePane({
  contractId,
  draftId,
  recalcVersion,
  onReadyToSave,
}) {
  const [existing, setExisting] = useState([]);
  const [updated, setUpdated] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [calcSchedule, setCalcSchedule] = useState([]);
  const [mergedPaymentDetails, setMergedPaymentDetails] = useState([]);
  const [amortData, setAmortData] = useState([]);

  const [parentPaymentDetails, setParentPaymentDetails] = useState([]);
  console.log("DRAFT ID IN PAYMENT CHANGE PANE", draftId);
  console.log("contract id HANGE PANE", contractId);
  // useEffect(() => {
  //   // Existing schedule (parent)
  //   axios
  //     .get(`${API}contracts/payment-view/${contractId}/`, {
  //       headers: authHeader(),
  //     })
  //     .then((res) => setExisting(res.data));

  //   // New schedule (draft)
  //   axios
  //     .get(`${API}contracts/payment-view/${draftId}/`, {
  //       headers: authHeader(),
  //     })
  //     .then((res) => setUpdated(res.data));

  //   // Loan payment details
  //   axios
  //     // .get(`${API}contracts/paymentDetail-view/${draftId}/`, {
  //     .get(`${API}contracts/LineOfCreditmodificationpaymentSchedule/?id=${draftId}`, {
  //       headers: authHeader(),
  //     })
  //     // .then((res) => setPaymentDetails(res.data));
  //     .then((res) => setPaymentDetails(res.data.response));
  // }, [contractId, draftId]);
  useEffect(() => {
    axios
      .get(`${API}contracts/payment-view/${contractId}/`, {
        headers: authHeader(),
      })
      .then((res) => setExisting(res.data || []));

    if (!draftId) {
      setUpdated([]);
      setCalcSchedule([]);
      setAmortData([]);
      setMergedPaymentDetails([]);
      return;
    }

    // Existing schedule (parent)
    axios
      .get(`${API}contracts/payment-view/${contractId}/`, {
        headers: authHeader(),
      })
      .then((res) => setExisting(res.data));

    // New schedule (draft)
    axios
      .get(`${API}contracts/payment-view/${draftId}/`, {
        headers: authHeader(),
      })
      .then((res) => setUpdated(res.data));

    // 🔥 Payment Details (AFTER recalculation)
    axios
      .get(`${API}contracts/LineOfCreditmodificationpaymentSchedule/?id=${draftId}`, {
        headers: authHeader(),
      })
      // .then((res) => setPaymentDetails(res.data.response));
      .then((res) => setCalcSchedule(res.data.response || []));

    axios
      .get(`${API}contracts/amortCalculation/?id=${draftId}`, {
        headers: authHeader(),
      })
      .then((res) => setAmortData(res.data.response || []));

    // }, [contractId, draftId,recalcVersion]);
  }, [contractId, draftId, recalcVersion]);

  useEffect(() => {
    axios
      .get(`${API}contracts/paymentDetail-view/${contractId}/`, {
        headers: authHeader(),
      })
      .then((res) => setParentPaymentDetails(res.data))
      .catch(console.error);
  }, [contractId]);

  console.log("PARENT PAYMENT DETAILS", parentPaymentDetails);
  // useEffect(() => {
  //   if (!parentPaymentDetails.length || !calcSchedule.length) return;

  //   const merged = [];

  //   /* =====================================================
  //      1️⃣ INTEREST ONLY — ALWAYS FROM PARENT
  //   ===================================================== */
  //   const parentInterestOnly = parentPaymentDetails
  //     .filter(p => p.paymenttype === "Interest Only")
  //     .sort((a, b) => a.pmt_no - b.pmt_no);

  //   parentInterestOnly.forEach(p => {
  //     merged.push({
  //       id: p.id,
  //       paymentdate: p.paymentdate,
  //       startdate: p.startdate,
  //       enddate: p.enddate,
  //       payment_type: "Interest Only",

  //       periodicamount_decimal2: p.periodicamount,
  //       interest_decimal2: p.interest,
  //       principal_decimal2: 0,

  //       beg_receivable: p.beginbv,
  //       end_receivable: p.endbv,

  //       pmt_no: p.pmt_no,

  //       billed: true,
  //       date_billed: p.date_billed,

  //       txn_number: p.txn_number,
  //       transaction_number: p.transaction_number,
  //       paymentdetail_id: p.paymentdetail_id,

  //       source: "parent",
  //     });
  //   });

  //   /* =====================================================
  //      2️⃣ PARENT RENT LOOKUP (BY PAYMENTDATE)
  //   ===================================================== */
  //   const parentRentMap = {};
  //   parentPaymentDetails
  //     .filter(p => p.paymenttype === "Rent")
  //     .forEach(p => {
  //       parentRentMap[p.paymentdate] = p;
  //     });

  //   /* =====================================================
  //      3️⃣ MERGE RENT — KEEP PMT 1 + MAP INVOICES
  //   ===================================================== */
  //   calcSchedule.forEach(calc => {
  //     const parent = parentRentMap[calc.paymentdate];
  //     const isBilled = parent && parent.date_billed !== null;

  //     merged.push({
  //       paymentdate: calc.paymentdate,
  //       startdate: calc.startdate,
  //       enddate: calc.enddate,
  //       payment_type: "Rent",

  //       periodicamount_decimal2: isBilled
  //         ? parent.periodicamount
  //         : calc.periodicamount,

  //       interest_decimal2: isBilled
  //         ? parent.interest
  //         : calc.interest,

  //       principal_decimal2: isBilled
  //         ? parent.principal_recovery
  //         : calc.principal,

  //       beg_receivable: isBilled
  //         ? parent.beginbv
  //         : calc.beg_receivable,

  //       end_receivable: isBilled
  //         ? parent.endbv
  //         : calc.end_receivable,

  //       pmt_no: calc.pmt_no,

  //       billed: isBilled,
  //       date_billed: isBilled ? parent.date_billed : null,

  //       // ✅ INVOICE / TXN — ONLY FROM PARENT
  //       txn_number: isBilled ? parent.txn_number : null,
  //       transaction_number: isBilled ? parent.transaction_number : null,
  //       paymentdetail_id: isBilled ? parent.paymentdetail_id : null,

  //       source: isBilled ? "parent" : "calc",
  //     });
  //   });

  //   setMergedPaymentDetails(merged);
  // }, [parentPaymentDetails, calcSchedule]);
  // useEffect(() => {
  //   if (!parentPaymentDetails.length || !calcSchedule.length) return;

  //   // 1️⃣ Split parent rows
  //   const parentInterestOnly = parentPaymentDetails.filter(
  //     (p) => p.paymenttype === "Interest Only"
  //   );

  //   const parentRent = parentPaymentDetails.filter(
  //     (p) => p.paymenttype === "Rent"
  //   );

  //   const merged = [];

  //   console.log("PARENT INTEREST ONLY", parentInterestOnly);
  //   console.log("PARENT RENT", parentRent);
  //   console.log("CALCULATED SCHEDULE", calcSchedule);

  //   // 2️⃣ Always keep Interest Only rows
  //   parentInterestOnly.forEach((p) => {
  //     merged.push({
  //       id: p.id,
  //       paymentdate: p.paymentdate,
  //       startdate: p.startdate,
  //       enddate: p.enddate,
  //       payment_type: p.paymenttype,
  //       periodicamount_decimal2: p.periodicamount,
  //       interest_decimal2: p.interest,
  //       principal_decimal2: p.principal_recovery,
  //       beg_receivable: p.beginbv,
  //       end_receivable: p.endbv,
  //       pmt_no: p.pmt_no,

  //       billed: p.date_billed !== null,
  //       date_billed: p.date_billed,
  //       paymentdetail_id: p.transaction_number,
  //       txn_number: p.txn_number,

  //       source: "parent",
  //     });
  //   });

  //   // 3️⃣ Merge Rent rows (sequence-based)
  //   let rentIndex = 0;

  //   calcSchedule.forEach((calc) => {
  //     const parent = parentRent[rentIndex];

  //     const isBilled = parent && parent.date_billed !== null;

  //     merged.push({
  //       paymentdate: calc.paymentdate,
  //       startdate: calc.startdate,
  //       enddate: calc.enddate,
  //       payment_type: "Rent",

  //       // 🔒 billed → parent amount
  //       // ✏️ unbilled → new calc amount
  //       periodicamount_decimal2: isBilled
  //         ? parent.periodicamount
  //         : calc.periodicamount,

  //       interest_decimal2: isBilled ? parent.interest : calc.interest,
  //       principal_decimal2: isBilled
  //         ? parent.principal_recovery
  //         : calc.principal,

  //       beg_receivable: isBilled ? parent.beginbv : calc.beg_receivable,
  //       end_receivable: isBilled ? parent.endbv : calc.end_receivable,

  //       pmt_no: calc.pmt_no,

  //       billed: isBilled,
  //       date_billed: isBilled ? parent.date_billed : null,
  //       txn_number: isBilled ? parent.txn_number : null,
  //       paymentdetail_id: parent.transaction_number,

  //       source: isBilled ? "parent" : "calc",
  //     });

  //     rentIndex += 1;
  //   });

  //   setMergedPaymentDetails(merged);
  // }, [parentPaymentDetails, calcSchedule]);

  console.log("calc schedule", calcSchedule);
  // useEffect(() => {
  //   if (!parentPaymentDetails.length || !calcSchedule.length) return;

  //   // -------------------------------
  //   // 1️⃣ Split parent rows
  //   // -------------------------------
  //   const parentInterestOnly = parentPaymentDetails.filter(
  //     p => p.paymenttype === "Interest Only"
  //   );

  //   const parentRent = parentPaymentDetails.filter(
  //     p => p.paymenttype === "Rent"
  //   );

  //   const billedRent = parentRent.filter(p => p.date_billed);
  //   const lastBilled = billedRent[billedRent.length - 1];

  //   const lastBilledPmtNo = lastBilled?.pmt_no || 0;
  //   const lastBilledDate = lastBilled
  //     ? new Date(lastBilled.paymentdate)
  //     : null;

  //   const merged = [];

  //   // -------------------------------
  //   // 2️⃣ Always keep Interest Only
  //   // -------------------------------
  //   parentInterestOnly.forEach(p => {
  //     merged.push({
  //       id: p.id,
  //       paymentdate: p.paymentdate,
  //       startdate: p.startdate,
  //       enddate: p.enddate,
  //       payment_type: p.paymenttype,

  //       periodicamount_decimal2: p.periodicamount,
  //       interest_decimal2: p.interest,
  //       principal_decimal2: p.principal_recovery,

  //       beg_receivable: p.beginbv,
  //       end_receivable: p.endbv,

  //       pmt_no: p.pmt_no,
  //       billed: true,
  //       date_billed: p.date_billed,
  //       txn_number: p.txn_number,
  //       paymentdetail_id: p.transaction_number,

  //       source: "parent",
  //     });
  //   });

  //   // -------------------------------
  //   // 3️⃣ Add billed Rent rows (as-is)
  //   // -------------------------------
  //   billedRent.forEach(p => {
  //     merged.push({
  //       id: p.id,
  //       paymentdate: p.paymentdate,
  //       startdate: p.startdate,
  //       enddate: p.enddate,
  //       payment_type: "Rent",

  //       periodicamount_decimal2: p.periodicamount_decimal2,
  //       interest_decimal2: p.interest_decimal2,
  //       principal_decimal2: p.Principal_decimal2,

  //       beg_receivable: p.beginbv,
  //       end_receivable: p.endbv,

  //       pmt_no: p.pmt_no,
  //       billed: true,
  //       date_billed: p.date_billed,
  //       txn_number: p.txn_number,
  //       paymentdetail_id: p.transaction_number,

  //       source: "parent",
  //     });
  //   });

  //   // -------------------------------
  //   // 4️⃣ Add future calc rows ONLY
  //   // -------------------------------
  //   // const futureCalc = calcSchedule.filter(c =>
  //   //   lastBilledDate
  //   //     ? new Date(c.paymentdate) > lastBilledDate
  //   //     : true
  //   // );

  //    const futureCalc = calcSchedule.filter(c => {
  //     const payDate = new Date(c.paymentdate).getTime();

  //     // ❌ drop bridge / carry-forward row
  //     if (lastBilledDate && payDate === lastBilledDate) {
  //       return false;
  //     }

  //     // ✅ keep true future rows only
  //     return !lastBilledDate || payDate > lastBilledDate;
  //   });
  //   futureCalc.forEach((c, index) => {
  //     merged.push({
  //       paymentdate: c.paymentdate,
  //       startdate: c.startdate,
  //       enddate: c.enddate,
  //       payment_type: "Rent",

  //       periodicamount_decimal2: c.periodicamount_decimal2,
  //       interest_decimal2: c.interest_decimal2,
  //       principal_decimal2: c.principal_decimal2,

  //       beg_receivable: c.beg_receivable,
  //       end_receivable: c.end_receivable,

  //       pmt_no: lastBilledPmtNo + index + 1,
  //       billed: false,
  //       date_billed: null,
  //       txn_number: null,

  //       source: "calc",
  //     });
  //   });
  //   merged.sort((a, b) => {
  //     if (a.pmt_no === b.pmt_no) {
  //       return new Date(a.paymentdate) - new Date(b.paymentdate);
  //     }
  //     return Number(a.pmt_no) - Number(b.pmt_no);
  //   });

  //   setMergedPaymentDetails(merged);
  // }, [parentPaymentDetails, calcSchedule]);
  // console.log("PAYMENT DETAILS", paymentDetails);

  useEffect(() => {
    if (!parentPaymentDetails.length || !calcSchedule.length) return;

    // -------------------------------
    // 1️⃣ Split parent rows
    // -------------------------------
    const parentInterestOnly = parentPaymentDetails.filter(
      (p) => p.paymenttype === "Interest Only",
    );

    const calcInterestOnly = calcSchedule.filter(
      (p) => p.payment_type === "Interest Only",
    );

    const ioPeriodSet = new Set(
  calcInterestOnly.map(c => `${c.startdate}_${c.enddate}`)
);

    // const calcRent = calcSchedule.filter((p) => p.payment_type === "Rent");
    const calcRent = calcSchedule
  .filter((p) => p.payment_type === "Rent")
  .filter((p) => {
    const key = `${p.startdate}_${p.enddate}`;
    return !ioPeriodSet.has(key); // ❌ remove overlap
  });
    const calcRentMap = {};
calcRent.forEach((c) => {
  calcRentMap[`${c.startdate}_${c.enddate}`] = c;
});

    const parentRent = parentPaymentDetails.filter(
      (p) => p.paymenttype === "Rent",
    );

    const billedRent = parentRent.filter((p) => p.date_billed);
    const unbilledRent = parentRent.filter((p) => !p.date_billed);

    const lastBilledPmtNo =
      billedRent.length > 0
        ? Math.max(...billedRent.map((r) => Number(r.pmt_no)))
        : 0;
      const anyBilled = parentPaymentDetails.some(
    (p) => p.date_billed !== null
  );


    const merged = [];

    // -------------------------------
    // 2️⃣ Always keep Interest Only
    // -------------------------------
    // parentInterestOnly.forEach(p => {
    //   merged.push({
    //     id: p.id,
    //     paymentdate: p.paymentdate,
    //     startdate: p.startdate,
    //     enddate: p.enddate,
    //     payment_type: "Interest Only",

    //     periodicamount_decimal2: p.periodicamount_decimal2,
    //     interest_decimal2: p.interest_decimal2,
    //     principal_decimal2: 0,

    //     beg_receivable: p.beginbv,
    //     end_receivable: p.endbv,

    //     pmt_no: p.pmt_no,
    //     billed: true,
    //     date_billed: p.date_billed,
    //     txn_number: p.transaction_number,
    //     paymentdetail_id: p.transaction_number,

    //     source: "parent",
    //   });
    // });
    // calcInterestOnly.forEach(p => {
    //   merged.push({
    //     id: p.id,
    //     paymentdate: p.paymentdate,
    //     startdate: p.startdate,
    //     enddate: p.enddate,
    //     payment_type: "Interest Only",

    //     periodicamount_decimal2: p.periodicamount_decimal2,
    //     interest_decimal2: p.interest_decimal2,
    //     principal_decimal2: 0,

    //     beg_receivable: p.beg_receivable,
    //     end_receivable: p.end_receivable,

    //     pmt_no: p.pmt_no,
    //     billed: true,
    //     date_billed: p.date_billed,
    //     txn_number: p.transaction_number,
    //     paymentdetail_id: p.transaction_number,

    //     source: "parent",
    //   });
    // });
    parentInterestOnly.forEach((parentRow, index) => {
      const calc = calcInterestOnly[index];

      const isBilled = parentRow.date_billed !== null;

      merged.push({
        paymentdate: parentRow.paymentdate,
        startdate: parentRow.startdate,
        enddate: parentRow.enddate,
        payment_type: "Interest Only",

        periodicamount_decimal2: isBilled
          ? parentRow.periodicamount_decimal2
          : calc?.periodicamount_decimal2,

        interest_decimal2: isBilled
          ? parentRow.interest_decimal2
          : calc?.interest_decimal2,

        principal_decimal2: 0,

        beg_receivable: isBilled ? parentRow.beginbv : calc?.beg_receivable,

        end_receivable: isBilled ? parentRow.endbv : calc?.end_receivable,

        pmt_no: parentRow.pmt_no,

        billed: isBilled,
        date_billed: isBilled ? parentRow.date_billed : null,

        txn_number: isBilled ? parentRow.transaction_number : null,
        paymentdetail_id: isBilled ? parentRow.paymentdetail_id : null,

        source: isBilled ? "parent" : "calc",
      });
    });

    // -------------------------------
    // 3️⃣ Add billed Rent rows (as-is)
    // -------------------------------
    billedRent.forEach((p) => {
      merged.push({
        id: p.id,
        paymentdate: p.paymentdate,
        startdate: p.startdate,
        enddate: p.enddate,
        payment_type: "Rent",

        periodicamount_decimal2: p.periodicamount_decimal2,
        interest_decimal2: p.interest_decimal2,
        principal_decimal2: p.Principal_decimal2,

        beg_receivable: p.beginbv,
        end_receivable: p.endbv,

        pmt_no: p.pmt_no,
        billed: true,
        date_billed: p.date_billed,
        txn_number: p.transaction_number,
        paymentdetail_id: p.transaction_number,

        source: "parent",
      });
    });

    // 🚨 IMPORTANT FIX
    // if (billedRent.length === 0) {
      if (!anyBilled) {

      const merged = [];

      // ✅ Interest Only from calc
      // calcInterestOnly.forEach(p => {
      //   merged.push({
      //     ...p,
      //     payment_type: "Interest Only",
      //     billed: false,
      //     source: "calc",
      //   });
      // });
      parentInterestOnly.forEach((parentRow, index) => {
        const calc = calcInterestOnly[index];

        merged.push({
          paymentdate: parentRow.paymentdate,
          startdate: parentRow.startdate,
          enddate: parentRow.enddate,
          payment_type: "Interest Only",

          periodicamount_decimal2: calc?.periodicamount_decimal2  !== undefined ? calc?.periodicamount_decimal2  : parentRow.periodicamount_decimal2,
          interest_decimal2: calc?.interest_decimal2 !== undefined ? calc?.interest_decimal2 : parentRow.interest_decimal2,
          principal_decimal2: 0,

          beg_receivable: calc?.beg_receivable !== undefined ? calc?.beg_receivable : parentRow.beginbv,
          end_receivable: calc?.end_receivable !== undefined ? calc?.end_receivable : parentRow.endbv,

          pmt_no: parentRow.pmt_no,

          billed: false,
          date_billed: null,
          txn_number: null,

          source: "calc",
        });
      });

      // ✅ Rent ONLY from calc
      // calcRent.forEach((p) => {
      //   merged.push({
      //     ...p,
      //     payment_type: "Rent",
      //     billed: false,
      //     source: "calc",
      //   });
      // ✅ Rent (use map, not index)
calcRent.forEach((c) => {
  merged.push({
    paymentdate: c.paymentdate,
    startdate: c.startdate,
    enddate: c.enddate,
    payment_type: "Rent",

    periodicamount_decimal2: c.periodicamount_decimal2,
    interest_decimal2: c.interest_decimal2,
    principal_decimal2: c.principal_decimal2,

    beg_receivable: c.beg_receivable,
    end_receivable: c.end_receivable,

    pmt_no: c.pmt_no,

    billed: false,
    date_billed: null,
    txn_number: null,

    source: "calc",
  });

      });

      setMergedPaymentDetails(merged);
      return; // ⛔ STOP execution here
    }

    // -------------------------------
    // 4️⃣ Overlay calc rows onto unbilled rent
    // -------------------------------
    unbilledRent.forEach((parentRow, index) => {
      // const calc = calcSchedule[index]; // 👈 index-based, NOT date-based
      // const calc =     calcRent[index]; // 👈 index-based, NOT date-based
      // const calc = calcRent[billedRent.length + index];
      const key = `${parentRow.startdate}_${parentRow.enddate}`;
      const calc = calcRentMap[key];
      merged.push({
        paymentdate: parentRow.paymentdate,
        startdate: parentRow.startdate,
        enddate: parentRow.enddate,
        payment_type: "Rent",

        periodicamount_decimal2: calc
         ? calc.periodicamount_decimal2
          : parentRow.periodicamount_decimal2, 
    //     periodicamount_decimal2: calc?.periodicamount_decimal2 !== undefined
    // ? calc.periodicamount_decimal2
    // : parentRow.periodicamount_decimal2,

        interest_decimal2: calc
          ? calc.interest_decimal2
          : parentRow.interest_decimal2,

        principal_decimal2: calc
          ? calc.principal_decimal2
          : parentRow.Principal_decimal2,

        beg_receivable: calc ? calc.beg_receivable : parentRow.beginbv,

        end_receivable: calc ? calc.end_receivable : parentRow.endbv,

        pmt_no: parentRow.pmt_no,
        billed: false,
        date_billed: null,
        txn_number: null,

        source: "calc",
      });
      console.log("BILLED COUNT", billedRent.length);
      console.log("CALC RENT LENGTH", calcRent.length);
    });

    // -------------------------------
    // 5️⃣ Final sort
    // -------------------------------
    merged.sort((a, b) => {
      if (Number(a.pmt_no) === Number(b.pmt_no)) {
        return new Date(a.paymentdate) - new Date(b.paymentdate);
      }
      return Number(a.pmt_no) - Number(b.pmt_no);
    });

    setMergedPaymentDetails(merged);
  }, [parentPaymentDetails, calcSchedule]);

  useEffect(() => {
    if (
      mergedPaymentDetails.length > 0 &&
      typeof onReadyToSave === "function"
    ) {
      onReadyToSave(mergedPaymentDetails, amortData);
    }
  }, [mergedPaymentDetails, amortData]);

  return (
    <>
      <div className="">
        <div className="">
          {/* EXISTING */}
          <h5 className="mt-4">Existing Payment Schedule</h5>
          <ScheduleTable data={existing} contractType="Loan" />

          {/* NEW */}
          <h5 className="mt-4">New Payment Schedule</h5>
          <ScheduleTable data={updated} contractType="Loan" />

          {/* PAYMENT DETAILS */}
          <h5 className="mt-4"></h5>
          {/* <LoanPaymentDetailView contracttype="Loan" paymentdetails={paymentDetails} /> */}
          <LineOfCreditPaymentDetailView
            contracttype="Line of Credit"
            paymentdetails={mergedPaymentDetails}
          />

          {/* <h5 className="mt-4">Amort Schedule</h5>
          <MaterialTable
            columns={[
              {
                title: "Payment Date",
                field: "payment_date",
              },
              {
                title: "Opening",
                field: "opening_balance",
                render: (rowData) => Helper.Amount(rowData.opening_balance),
              },
              {
                title: "Interest",
                field: "interest_amount",
                render: (rowData) => Helper.Amount(rowData.interest_amount),
              },
              {
                title: "Principal",
                field: "principal_amount",
                render: (rowData) => Helper.Amount(rowData.principal_amount),
              },
              {
                title: "Closing",
                field: "closing_balance",
                render: (rowData) => Helper.Amount(rowData.closing_balance),
              },
            ]}
            data={amortData}
            options={{
              search: false,
              toolbar: false,
              paging: true,
              pageSize: 3,
              pageSizeOptions: [3, 5, 10, 20],
            }}
          /> */}
        </div>
      </div>
    </>
  );
}

function ScheduleTable({ data, contractType }) {
  const columns = [
    {
      title: "No. Of Payments",
      field: "no_of_payments",
      render: (rowData) => (
        <>
          <div className="d-xl-none tc d-md-none d-lg-none">
            {"No. Of Payments"}
          </div>
          <div>{rowData.no_of_payments}</div>
        </>
      ),
      headerStyle: {
        verticalAlign: "inherit",
        fontWeight: "bold",
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        fontSize: 12,
      },
    },
    {
      title: "Payment Type",
      field: "payment_type",
      render: (rowData) => (
        <>
          <div className="d-xl-none tc d-md-none d-lg-none">Payment Type</div>
          <div>{rowData.payment_type === "Rent" ? "Payment" : rowData.payment_type}</div>
        </>
      ),
      headerStyle: {
        verticalAlign: "inherit",
        fontWeight: "bold",
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        fontSize: 12,
      },
    },
    {
      title: "Payment Amount",
      field: "amount",
      render: (rowData) => (
        <>
          <div className="d-xl-none tc d-md-none d-lg-none">Payment Amount</div>
          <div className="text-end">{Helper.Amount(rowData.amount)}</div>
        </>
      ),
      headerStyle: {
        verticalAlign: "inherit",
        fontWeight: "bold",
        textAlign: "right",
      },
      cellStyle: {
        textAlign: "left",
        fontSize: 12,
      },
    },

    // 🔥 INTEREST — ONLY FOR LOAN
    // ...(contractType === "Loan"
    //   ? [
    //       {
    //         title: "Interest",
    //         field: "interest",
    //         render: (rowData) => (
    //           <>
    //             <div className="d-xl-none tc d-md-none d-lg-none">Interest</div>
    //             <div className="text-end">
    //               {Helper.Amount(rowData.interest || 0)}
    //             </div>
    //           </>
    //         ),
    //         headerStyle: {
    //               verticalAlign: "inherit",
    //               fontWeight: "bold",
    //               textAlign: "left",
    //             },
    //             cellStyle: {
    //               textAlign: "left",
    //               fontSize: 12,
    //             },
    //       },
    //     ]
    //   : []),

    {
      title: "Start Date",
      field: "start_date",
      render: (rowData) => (
        <>
          <div className="d-xl-none tc d-md-none d-lg-none">Start Date</div>
          <div>{Helper.DateNormal(rowData.start_date)}</div>
        </>
      ),
      headerStyle: {
        verticalAlign: "inherit",
        fontWeight: "bold",
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        fontSize: 12,
      },
    },
    {
      title: "End Date",
      field: "end_date",
      render: (rowData) => (
        <>
          <div className="d-xl-none tc d-md-none d-lg-none">End Date</div>
          <div>{Helper.DateNormal(rowData.end_date)}</div>
        </>
      ),
      headerStyle: {
        verticalAlign: "inherit",
        fontWeight: "bold",
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        fontSize: 12,
      },
    },
  ];

  return (
    <MaterialTable
      style={{
        backgroundColor: "var(--bs-table-bg)",
        borderBottomWidth: "1px",

        boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
      }}
      columns={columns}
      data={data}
      options={{
        search: false,
        toolbar: false,
        paging: true,
        pageSize: 3,
        showFirstLastPageButtons: false,
        actionsColumnIndex: -1,
        emptyRowsWhenPaging: false, // To avoid of having empty rows

        pageSizeOptions: [3, 15, 20, 50],
        paginationType: "stepped",

        headerStyle: {
          backgroundColor: "white",
          color: "#245C7F",
          fontSize: 12,
        },
        rowStyle: (rowData) => ({
          backgroundColor:
            rowData.is_historical || rowData.billed ? "#f0f0f0" : "#ffffff",
          pointerEvents:
            rowData.is_historical || rowData.billed ? "none" : "auto",
        }),
      }}
    />
  );
}
